var _path, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _path3, _ellipse, _ellipse2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 341,
    viewBox: "0 0 476 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.286 164.95C257.257 165.306 257.226 165.662 257.194 166.018C257.143 165.656 257.097 165.294 257.052 164.931L257.286 164.95Z",
    fill: "#151790"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 355.326,
    y: 164.93,
    width: 6.02103,
    height: 24.8236,
    rx: 3.01052,
    stroke: "#2C25C4",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 354.576,
    y: 152.899,
    width: 7.52103,
    height: 7.52103,
    rx: 3.76052,
    fill: "#2C25C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 329.252,
    y: 153.899,
    width: 5.52103,
    height: 5.52103,
    rx: 2.76052,
    fill: "#2C25C4",
    stroke: "#2C25C4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.397 129.885C334.848 129.885 344.941 139.979 344.941 152.43V187.015C344.941 189.586 342.857 191.671 340.286 191.671H304.507C301.936 191.671 299.852 189.586 299.852 187.015V152.43C299.852 139.979 309.946 129.885 322.397 129.885Z",
    stroke: "#2C25C4",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 356.456,
    y: 166.06,
    width: 3.76052,
    height: 22.5631,
    rx: 1.88026,
    stroke: "#2C25C4",
    strokeWidth: 3.76052
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 354.576,
    y: 152.899,
    width: 7.52103,
    height: 7.52103,
    rx: 3.76052,
    fill: "#2C25C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 329.252,
    y: 153.899,
    width: 5.52103,
    height: 5.52103,
    rx: 2.76052,
    fill: "#2C25C4",
    stroke: "#2C25C4",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.772 99.2688L101.202 69.3031C91.755 74.8851 83.2157 81.9547 75.9494 90.2926C61.7315 106.608 53.1177 126.941 51.3426 148.378C49.5674 169.816 54.7221 191.258 66.0677 209.63C77.4134 228.002 94.3675 242.361 114.5 250.65C134.633 258.939 156.911 260.732 178.141 255.772C199.371 250.812 218.463 239.353 232.681 223.038C234.941 220.444 237.061 217.748 239.033 214.962C241.138 217.934 243.41 220.806 245.845 223.561C261.7 241.507 283.43 253.413 307.261 257.211C331.092 261.01 355.521 256.462 376.305 244.356C397.089 232.25 415.131 212.684 421.041 190.94L423.967 179.073L387.327 179.063C382.018 193.708 371.675 206.058 358.093 213.968C344.512 221.879 328.548 224.852 312.975 222.369C297.402 219.887 283.203 212.107 272.842 200.38C262.481 188.653 256.612 173.719 256.255 158.171C255.899 142.623 261.076 127.443 270.888 115.266C280.701 103.088 294.529 94.6834 309.972 91.5093C325.416 88.3353 341.499 90.5929 355.43 97.8899C369.36 105.187 380.798 117.828 386.773 132.221H425C423.9 129.61 423.042 127.382 422.184 125.154C421.326 122.926 420.468 120.698 419.369 118.088C410.225 96.0625 393.547 77.8886 372.228 66.7219C350.91 55.555 326.298 52.1004 302.666 56.9575C279.033 61.8146 257.872 74.6771 242.856 93.3116C227.84 111.946 219.917 135.176 220.463 158.969C220.568 163.532 220.983 168.061 221.697 172.526C219.147 183.054 214.082 192.885 206.861 201.17C197.328 212.11 184.526 219.793 170.291 223.119C156.056 226.445 141.118 225.243 127.618 219.685C114.118 214.127 102.75 204.499 95.1425 192.18C87.5349 179.861 84.0785 165.483 85.2688 151.109C86.4591 136.734 92.2349 123.1 101.768 112.16C106.141 107.143 111.202 102.81 116.772 99.2688Z",
    fill: "url(#paint0_linear_146_3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6222,
    cy: 20.4116,
    rx: 20.6222,
    ry: 20.4116,
    transform: "matrix(0.92914 0.369727 -0.378908 0.925434 124.324 44.6292)",
    fill: "#2C25C4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.95,
    cy: 30.3704,
    rx: 20.663,
    ry: 20.3704,
    fill: "#8C18C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.812 132.801C180.682 135.047 187.287 132.176 189.564 126.389C191.842 120.602 188.93 114.09 183.06 111.845C177.19 109.599 170.585 112.47 168.307 118.257C166.029 124.044 168.942 130.556 174.812 132.801Z",
    fill: "url(#paint1_linear_146_3)",
    stroke: "url(#paint2_linear_146_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.312 180.827C201.182 183.073 207.685 180.462 209.836 174.997C211.987 169.531 208.972 163.28 203.102 161.035C197.232 158.79 190.73 161.4 188.579 166.865C186.427 172.331 189.442 178.582 195.312 180.827Z",
    fill: "url(#paint3_linear_146_3)",
    stroke: "url(#paint4_linear_146_3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.775 201.489C153.645 203.735 160.251 200.864 162.528 195.077C164.806 189.29 161.894 182.779 156.024 180.533C150.154 178.288 143.549 181.159 141.271 186.945C138.993 192.732 141.905 199.244 147.775 201.489Z",
    fill: "url(#paint5_linear_146_3)",
    stroke: "url(#paint6_linear_146_3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.485 173.254C125.355 175.499 131.96 172.629 134.238 166.842C136.515 161.055 133.603 154.543 127.733 152.298C121.863 150.052 115.258 152.923 112.98 158.71C110.703 164.497 113.615 171.009 119.485 173.254Z",
    fill: "url(#paint7_linear_146_3)",
    stroke: "url(#paint8_linear_146_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.065 133.67C140.935 135.916 147.54 133.045 149.818 127.258C152.096 121.471 149.183 114.96 143.313 112.714C137.443 110.469 130.838 113.34 128.56 119.127C126.283 124.913 129.195 131.425 135.065 133.67Z",
    fill: "url(#paint9_linear_146_3)",
    stroke: "url(#paint10_linear_146_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.356 161.906C167.921 163.652 173.059 161.419 174.83 156.919C176.602 152.418 174.337 147.353 169.771 145.607C165.206 143.86 160.068 146.093 158.297 150.594C156.525 155.095 158.79 160.159 163.356 161.906Z",
    fill: "url(#paint11_linear_146_3)",
    stroke: "url(#paint12_linear_146_3)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.747 120.533L168.572 121.036",
    stroke: "url(#paint13_linear_146_3)",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M183.273 132.017L195.101 160.653",
    stroke: "url(#paint14_linear_146_3)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.324 176.24L161.735 186.737",
    stroke: "url(#paint15_linear_146_3)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.886 133.601L149.202 180.604",
    stroke: "url(#paint16_linear_146_3)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.224 171.047L142.646 183.453",
    stroke: "url(#paint17_linear_146_3)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.818 154.818L169.823 128.213",
    stroke: "url(#paint18_linear_146_3)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.262 130.299L160.852 147.553",
    stroke: "url(#paint19_linear_146_3)",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.372 158.083L189.266 165.12",
    stroke: "url(#paint20_linear_146_3)",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.356 161.906L156.024 180.534",
    stroke: "url(#paint21_linear_146_3)",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.114 317.058C28.378 317.058 25.876 316.59 23.608 315.654C21.34 314.718 19.378 313.386 17.722 311.658C16.066 309.894 14.77 307.824 13.834 305.448C12.934 303.036 12.484 300.408 12.484 297.564C12.484 294.828 12.97 292.29 13.942 289.95C14.914 287.61 16.264 285.558 17.992 283.794C19.72 282.03 21.736 280.662 24.04 279.69C26.344 278.718 28.846 278.232 31.546 278.232C33.382 278.232 35.164 278.502 36.892 279.042C38.62 279.582 40.204 280.338 41.644 281.31C43.084 282.246 44.29 283.344 45.262 284.604L40.78 289.518C39.844 288.546 38.872 287.736 37.864 287.088C36.892 286.404 35.866 285.9 34.786 285.576C33.742 285.216 32.662 285.036 31.546 285.036C29.89 285.036 28.324 285.342 26.848 285.954C25.408 286.566 24.148 287.43 23.068 288.546C22.024 289.662 21.196 290.994 20.584 292.542C19.972 294.054 19.666 295.746 19.666 297.618C19.666 299.526 19.954 301.254 20.53 302.802C21.142 304.35 21.988 305.682 23.068 306.798C24.184 307.914 25.498 308.778 27.01 309.39C28.558 309.966 30.25 310.254 32.086 310.254C33.274 310.254 34.426 310.092 35.542 309.768C36.658 309.444 37.684 308.994 38.62 308.418C39.592 307.806 40.474 307.104 41.266 306.312L44.722 311.874C43.858 312.846 42.706 313.728 41.266 314.52C39.826 315.312 38.206 315.942 36.406 316.41C34.642 316.842 32.878 317.058 31.114 317.058Z",
    fill: "#151790"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5481 317.058C59.2081 317.058 57.0841 316.41 55.1761 315.114C53.2681 313.818 51.7381 312.054 50.5861 309.822C49.4341 307.59 48.8581 305.052 48.8581 302.208C48.8581 299.364 49.4341 296.826 50.5861 294.594C51.7381 292.362 53.3041 290.616 55.2841 289.356C57.2641 288.096 59.4961 287.466 61.9801 287.466C63.4201 287.466 64.7341 287.682 65.9221 288.114C67.1101 288.51 68.1541 289.086 69.0541 289.842C69.9541 290.598 70.6921 291.462 71.2681 292.434C71.8801 293.406 72.2941 294.45 72.5101 295.566L71.0521 295.188V288.06H77.7481V316.518H70.9981V309.714L72.5641 309.444C72.3121 310.416 71.8441 311.37 71.1601 312.306C70.5121 313.206 69.6841 314.016 68.6761 314.736C67.7041 315.42 66.6061 315.978 65.3821 316.41C64.1941 316.842 62.9161 317.058 61.5481 317.058ZM63.3841 311.172C64.9321 311.172 66.3001 310.794 67.4881 310.038C68.6761 309.282 69.5941 308.238 70.2421 306.906C70.9261 305.538 71.2681 303.972 71.2681 302.208C71.2681 300.48 70.9261 298.95 70.2421 297.618C69.5941 296.286 68.6761 295.242 67.4881 294.486C66.3001 293.73 64.9321 293.352 63.3841 293.352C61.8361 293.352 60.4681 293.73 59.2801 294.486C58.1281 295.242 57.2281 296.286 56.5801 297.618C55.9321 298.95 55.6081 300.48 55.6081 302.208C55.6081 303.972 55.9321 305.538 56.5801 306.906C57.2281 308.238 58.1281 309.282 59.2801 310.038C60.4681 310.794 61.8361 311.172 63.3841 311.172ZM85.4485 316.518V288.06H91.9825L92.0905 297.132L91.1725 295.08C91.5685 293.64 92.2525 292.344 93.2245 291.192C94.1965 290.04 95.3125 289.14 96.5725 288.492C97.8685 287.808 99.2185 287.466 100.623 287.466C101.235 287.466 101.811 287.52 102.351 287.628C102.927 287.736 103.395 287.862 103.755 288.006L101.973 295.296C101.577 295.08 101.091 294.9 100.515 294.756C99.9385 294.612 99.3625 294.54 98.7865 294.54C97.8865 294.54 97.0225 294.72 96.1945 295.08C95.4025 295.404 94.7005 295.872 94.0885 296.484C93.4765 297.096 92.9905 297.816 92.6305 298.644C92.3065 299.436 92.1445 300.336 92.1445 301.344V316.518H85.4485ZM120.302 317.058C117.314 317.058 114.668 316.428 112.364 315.168C110.096 313.908 108.314 312.198 107.018 310.038C105.758 307.842 105.128 305.34 105.128 302.532C105.128 300.3 105.488 298.266 106.208 296.43C106.928 294.594 107.918 293.01 109.178 291.678C110.474 290.31 112.004 289.266 113.768 288.546C115.568 287.79 117.53 287.412 119.654 287.412C121.526 287.412 123.272 287.772 124.892 288.492C126.512 289.212 127.916 290.202 129.104 291.462C130.292 292.686 131.192 294.162 131.804 295.89C132.452 297.582 132.758 299.436 132.722 301.452L132.668 303.774H109.61L108.368 299.238H127.106L126.242 300.156V298.968C126.134 297.852 125.774 296.88 125.162 296.052C124.55 295.188 123.758 294.522 122.786 294.054C121.85 293.55 120.806 293.298 119.654 293.298C117.89 293.298 116.396 293.64 115.172 294.324C113.984 295.008 113.084 295.998 112.472 297.294C111.86 298.554 111.554 300.138 111.554 302.046C111.554 303.882 111.932 305.484 112.688 306.852C113.48 308.22 114.578 309.282 115.982 310.038C117.422 310.758 119.096 311.118 121.004 311.118C122.336 311.118 123.56 310.902 124.676 310.47C125.792 310.038 126.998 309.264 128.294 308.148L131.588 312.738C130.616 313.638 129.5 314.412 128.24 315.06C127.016 315.672 125.72 316.158 124.352 316.518C122.984 316.878 121.634 317.058 120.302 317.058ZM151.943 317.058C148.955 317.058 146.309 316.428 144.005 315.168C141.737 313.908 139.955 312.198 138.659 310.038C137.399 307.842 136.769 305.34 136.769 302.532C136.769 300.3 137.129 298.266 137.849 296.43C138.569 294.594 139.559 293.01 140.819 291.678C142.115 290.31 143.645 289.266 145.409 288.546C147.209 287.79 149.171 287.412 151.295 287.412C153.167 287.412 154.913 287.772 156.533 288.492C158.153 289.212 159.557 290.202 160.745 291.462C161.933 292.686 162.833 294.162 163.445 295.89C164.093 297.582 164.399 299.436 164.363 301.452L164.309 303.774H141.251L140.009 299.238H158.747L157.883 300.156V298.968C157.775 297.852 157.415 296.88 156.803 296.052C156.191 295.188 155.399 294.522 154.427 294.054C153.491 293.55 152.447 293.298 151.295 293.298C149.531 293.298 148.037 293.64 146.813 294.324C145.625 295.008 144.725 295.998 144.113 297.294C143.501 298.554 143.195 300.138 143.195 302.046C143.195 303.882 143.573 305.484 144.329 306.852C145.121 308.22 146.219 309.282 147.623 310.038C149.063 310.758 150.737 311.118 152.645 311.118C153.977 311.118 155.201 310.902 156.317 310.47C157.433 310.038 158.639 309.264 159.935 308.148L163.229 312.738C162.257 313.638 161.141 314.412 159.881 315.06C158.657 315.672 157.361 316.158 155.993 316.518C154.625 316.878 153.275 317.058 151.943 317.058ZM170.245 316.518V288.06H176.779L176.887 297.132L175.969 295.08C176.365 293.64 177.049 292.344 178.021 291.192C178.993 290.04 180.109 289.14 181.369 288.492C182.665 287.808 184.015 287.466 185.419 287.466C186.031 287.466 186.607 287.52 187.147 287.628C187.723 287.736 188.191 287.862 188.551 288.006L186.769 295.296C186.373 295.08 185.887 294.9 185.311 294.756C184.735 294.612 184.159 294.54 183.583 294.54C182.683 294.54 181.819 294.72 180.991 295.08C180.199 295.404 179.497 295.872 178.885 296.484C178.273 297.096 177.787 297.816 177.427 298.644C177.103 299.436 176.941 300.336 176.941 301.344V316.518H170.245ZM242.902 317.058C240.058 317.058 237.52 316.428 235.288 315.168C233.056 313.872 231.292 312.108 229.996 309.876C228.7 307.644 228.052 305.106 228.052 302.262C228.052 299.418 228.7 296.88 229.996 294.648C231.292 292.416 233.056 290.67 235.288 289.41C237.52 288.114 240.058 287.466 242.902 287.466C245.71 287.466 248.23 288.114 250.462 289.41C252.694 290.67 254.44 292.416 255.7 294.648C256.996 296.88 257.644 299.418 257.644 302.262C257.644 305.106 256.996 307.644 255.7 309.876C254.44 312.108 252.694 313.872 250.462 315.168C248.23 316.428 245.71 317.058 242.902 317.058ZM242.902 311.172C244.45 311.172 245.818 310.776 247.006 309.984C248.23 309.192 249.184 308.13 249.868 306.798C250.588 305.466 250.93 303.954 250.894 302.262C250.93 300.534 250.588 299.004 249.868 297.672C249.184 296.34 248.23 295.296 247.006 294.54C245.818 293.748 244.45 293.352 242.902 293.352C241.354 293.352 239.95 293.748 238.69 294.54C237.466 295.296 236.512 296.358 235.828 297.726C235.144 299.058 234.802 300.57 234.802 302.262C234.802 303.954 235.144 305.466 235.828 306.798C236.512 308.13 237.466 309.192 238.69 309.984C239.95 310.776 241.354 311.172 242.902 311.172ZM263.585 316.518V288.06H270.065L270.173 293.892L268.931 294.54C269.291 293.244 269.993 292.074 271.037 291.03C272.081 289.95 273.323 289.086 274.763 288.438C276.203 287.79 277.679 287.466 279.191 287.466C281.351 287.466 283.151 287.898 284.591 288.762C286.067 289.626 287.165 290.922 287.885 292.65C288.641 294.378 289.019 296.538 289.019 299.13V316.518H282.377V299.616C282.377 298.176 282.179 296.988 281.783 296.052C281.387 295.08 280.775 294.378 279.947 293.946C279.119 293.478 278.111 293.262 276.923 293.298C275.951 293.298 275.051 293.46 274.223 293.784C273.431 294.072 272.729 294.504 272.117 295.08C271.541 295.62 271.073 296.25 270.713 296.97C270.389 297.69 270.227 298.482 270.227 299.346V316.518H266.933C266.285 316.518 265.673 316.518 265.097 316.518C264.557 316.518 264.053 316.518 263.585 316.518ZM296.492 316.518V288.06H302.972L303.08 293.892L301.838 294.54C302.198 293.244 302.9 292.074 303.944 291.03C304.988 289.95 306.23 289.086 307.67 288.438C309.11 287.79 310.586 287.466 312.098 287.466C314.258 287.466 316.058 287.898 317.498 288.762C318.974 289.626 320.072 290.922 320.792 292.65C321.548 294.378 321.926 296.538 321.926 299.13V316.518H315.284V299.616C315.284 298.176 315.086 296.988 314.69 296.052C314.294 295.08 313.682 294.378 312.854 293.946C312.026 293.478 311.018 293.262 309.83 293.298C308.858 293.298 307.958 293.46 307.13 293.784C306.338 294.072 305.636 294.504 305.024 295.08C304.448 295.62 303.98 296.25 303.62 296.97C303.296 297.69 303.134 298.482 303.134 299.346V316.518H299.84C299.192 316.518 298.58 316.518 298.004 316.518C297.464 316.518 296.96 316.518 296.492 316.518ZM342.736 317.058C339.748 317.058 337.102 316.428 334.798 315.168C332.53 313.908 330.748 312.198 329.452 310.038C328.192 307.842 327.562 305.34 327.562 302.532C327.562 300.3 327.922 298.266 328.642 296.43C329.362 294.594 330.352 293.01 331.612 291.678C332.908 290.31 334.438 289.266 336.202 288.546C338.002 287.79 339.964 287.412 342.088 287.412C343.96 287.412 345.706 287.772 347.326 288.492C348.946 289.212 350.35 290.202 351.538 291.462C352.726 292.686 353.626 294.162 354.238 295.89C354.886 297.582 355.192 299.436 355.156 301.452L355.102 303.774H332.044L330.802 299.238H349.54L348.676 300.156V298.968C348.568 297.852 348.208 296.88 347.596 296.052C346.984 295.188 346.192 294.522 345.22 294.054C344.284 293.55 343.24 293.298 342.088 293.298C340.324 293.298 338.83 293.64 337.606 294.324C336.418 295.008 335.518 295.998 334.906 297.294C334.294 298.554 333.988 300.138 333.988 302.046C333.988 303.882 334.366 305.484 335.122 306.852C335.914 308.22 337.012 309.282 338.416 310.038C339.856 310.758 341.53 311.118 343.438 311.118C344.77 311.118 345.994 310.902 347.11 310.47C348.226 310.038 349.432 309.264 350.728 308.148L354.022 312.738C353.05 313.638 351.934 314.412 350.674 315.06C349.45 315.672 348.154 316.158 346.786 316.518C345.418 316.878 344.068 317.058 342.736 317.058ZM373.242 317.058C370.578 317.058 368.184 316.41 366.06 315.114C363.936 313.818 362.262 312.054 361.038 309.822C359.814 307.59 359.202 305.07 359.202 302.262C359.202 299.454 359.814 296.934 361.038 294.702C362.262 292.47 363.936 290.706 366.06 289.41C368.184 288.114 370.578 287.466 373.242 287.466C375.798 287.466 378.12 287.952 380.208 288.924C382.296 289.896 383.916 291.246 385.068 292.974L381.396 297.402C380.856 296.646 380.172 295.962 379.344 295.35C378.516 294.738 377.634 294.252 376.698 293.892C375.762 293.532 374.826 293.352 373.89 293.352C372.306 293.352 370.884 293.748 369.624 294.54C368.4 295.296 367.428 296.358 366.708 297.726C365.988 299.058 365.628 300.57 365.628 302.262C365.628 303.954 365.988 305.466 366.708 306.798C367.464 308.13 368.472 309.192 369.732 309.984C370.992 310.776 372.396 311.172 373.944 311.172C374.88 311.172 375.78 311.028 376.644 310.74C377.544 310.416 378.39 309.966 379.182 309.39C379.974 308.814 380.712 308.094 381.396 307.23L385.068 311.712C383.844 313.296 382.152 314.592 379.992 315.6C377.868 316.572 375.618 317.058 373.242 317.058ZM393.226 316.518V280.824H399.868V316.518H393.226ZM387.61 294.216V288.06H406.078V294.216H387.61Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.2 317.058C207.464 317.058 204.962 316.59 202.694 315.654C200.426 314.718 198.464 313.386 196.808 311.658C195.152 309.894 193.856 307.824 192.92 305.448C192.02 303.036 191.57 300.408 191.57 297.564C191.57 294.828 192.056 292.29 193.028 289.95C194 287.61 195.35 285.558 197.078 283.794C198.806 282.03 200.822 280.662 203.126 279.69C205.43 278.718 207.932 278.232 210.632 278.232C212.468 278.232 214.25 278.502 215.978 279.042C217.706 279.582 219.29 280.338 220.73 281.31C222.17 282.246 223.376 283.344 224.348 284.604L219.866 289.518C218.93 288.546 217.958 287.736 216.95 287.088C215.978 286.404 214.952 285.9 213.872 285.576C212.828 285.216 211.748 285.036 210.632 285.036C208.976 285.036 207.41 285.342 205.934 285.954C204.494 286.566 203.234 287.43 202.154 288.546C201.11 289.662 200.282 290.994 199.67 292.542C199.058 294.054 198.752 295.746 198.752 297.618C198.752 299.526 199.04 301.254 199.616 302.802C200.228 304.35 201.074 305.682 202.154 306.798C203.27 307.914 204.584 308.778 206.096 309.39C207.644 309.966 209.336 310.254 211.172 310.254C212.36 310.254 213.512 310.092 214.628 309.768C215.744 309.444 216.77 308.994 217.706 308.418C218.678 307.806 219.56 307.104 220.352 306.312L223.808 311.874C222.944 312.846 221.792 313.728 220.352 314.52C218.912 315.312 217.292 315.942 215.492 316.41C213.728 316.842 211.964 317.058 210.2 317.058Z",
    fill: "#8C18C3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M421.632 317.259H415.342L429.475 277.986H436.321L450.454 317.259H444.164L433.061 285.12H432.754L421.632 317.259ZM422.687 301.88H443.09V306.865H422.687V301.88Z",
    fill: "url(#paint22_linear_146_3)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M455.929 317.259V287.804H461.662V317.259H455.929ZM458.824 283.259C457.827 283.259 456.971 282.927 456.255 282.262C455.551 281.585 455.2 280.779 455.2 279.846C455.2 278.9 455.551 278.095 456.255 277.43C456.971 276.752 457.827 276.414 458.824 276.414C459.821 276.414 460.672 276.752 461.375 277.43C462.091 278.095 462.449 278.9 462.449 279.846C462.449 280.779 462.091 281.585 461.375 282.262C460.672 282.927 459.821 283.259 458.824 283.259Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_3",
    x1: 441.53,
    y1: 156.665,
    x2: 79.9282,
    y2: 156.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438628,
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677014,
    stopColor: "#4921C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851879,
    stopColor: "#2C25C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_146_3",
    x1: 183.06,
    y1: 111.845,
    x2: 175.014,
    y2: 132.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_146_3",
    x1: 183.06,
    y1: 111.845,
    x2: 175.014,
    y2: 132.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_146_3",
    x1: 203.102,
    y1: 161.035,
    x2: 195.503,
    y2: 180.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_146_3",
    x1: 203.102,
    y1: 161.035,
    x2: 195.503,
    y2: 180.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_146_3",
    x1: 156.024,
    y1: 180.533,
    x2: 147.978,
    y2: 201.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_146_3",
    x1: 156.024,
    y1: 180.533,
    x2: 147.978,
    y2: 201.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_146_3",
    x1: 127.733,
    y1: 152.298,
    x2: 119.687,
    y2: 173.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_146_3",
    x1: 127.733,
    y1: 152.298,
    x2: 119.687,
    y2: 173.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_146_3",
    x1: 143.313,
    y1: 112.714,
    x2: 135.267,
    y2: 133.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_146_3",
    x1: 143.313,
    y1: 112.714,
    x2: 135.267,
    y2: 133.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_146_3",
    x1: 169.771,
    y1: 145.607,
    x2: 163.513,
    y2: 161.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_146_3",
    x1: 169.771,
    y1: 145.607,
    x2: 163.513,
    y2: 161.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_146_3",
    x1: 160.305,
    y1: 117.874,
    x2: 158.07,
    y2: 123.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_146_3",
    x1: 193.311,
    y1: 135.857,
    x2: 185.265,
    y2: 156.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_146_3",
    x1: 179.696,
    y1: 172.175,
    x2: 172.544,
    y2: 190.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_146_3",
    x1: 153.105,
    y1: 137.893,
    x2: 138.354,
    y2: 176.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_146_3",
    x1: 138.31,
    y1: 173.757,
    x2: 135.628,
    y2: 180.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_146_3",
    x1: 157.423,
    y1: 123.47,
    x2: 143.566,
    y2: 159.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_146_3",
    x1: 156.119,
    y1: 133.687,
    x2: 152.096,
    y2: 144.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_146_3",
    x1: 182.048,
    y1: 161.019,
    x2: 181.601,
    y2: 162.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_146_3",
    x1: 163.823,
    y1: 162.085,
    x2: 156.671,
    y2: 180.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_146_3",
    x1: 440,
    y1: 265.259,
    x2: 440,
    y2: 330.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C25C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C18C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.01d2e9d491d50f0617504a691bffafaf.svg";
export { ForwardRef as ReactComponent };